import React, { useEffect, useState } from "react";
import { P } from "../engine";

// Campo numérico de la hoja 30: acepta coma decimal y punto de miles (1.234,5); «1.250» es ambiguo y se rechaza;
// «0.125» es 0,125. Vacío = null («Pendiente»). Valida con las MISMAS reglas que la importación (VALID_CAMPOS):
// `campo` es el nombre del dato en el archivo v2 (consumo, hs_dia, fc…).
export const mostrarNumero = (v) => (v == null || v === "" ? "" : String(v).replace(".", ","));

export function validarNumero(campo, texto) {
  const n = P.numPantalla(texto);
  const error = P.validarCampo(campo, n);
  return { valor: error ? undefined : n, error };
}

export function NumField({ value, campo, onChange, onError, ariaLabel, placeholder, disabled, className = "" }) {
  const [texto, setTexto] = useState(mostrarNumero(value));
  const [error, setError] = useState(null);

  // si el valor cambia desde afuera (otra fila, recarga), se muestra el nuevo
  useEffect(() => {
    setTexto(mostrarNumero(value));
    if (error) {
      setError(null);
      onError?.(null);
    }
  }, [value]);

  const confirmar = () => {
    const r = validarNumero(campo, texto);
    setError(r.error);
    onError?.(r.error);
    if (!r.error && r.valor !== value) onChange(r.valor);
  };

  return (
    <span className={`ep-num ${error ? "ep-num--error" : ""} ${className}`}>
      <input
        type="text"
        inputMode="decimal"
        autoComplete="off"
        aria-label={ariaLabel}
        aria-invalid={!!error}
        placeholder={placeholder}
        disabled={disabled}
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        onBlur={confirmar}
        onKeyDown={(e) => { if (e.key === "Enter") confirmar(); }}
      />
      {error && <span className="ep-num__error" role="alert">{error}</span>}
    </span>
  );
}
